import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceCreateMilestoneNotificationState = createStateReducer(
  initialState,
  {
    [events.createMilestoneSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "createMilestone",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.createMilestoneFailed]: (state, { error }) => ({
      ...state,
      queue: updateNotification(
        {
          key: "createMilestone",
          flags: pushIf({
            ...error,
            failure: !Object.values(error).includes(true),
          }),
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceCreateMilestoneNotificationState };
